import { NavLink } from 'react-router';

import {
  SidebarGroup,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  useSidebar,
} from '@/components/ui/sidebar';

export function NavSecondary({
  items,
}: {
  items: {
    title: string;
    url: string;
    icon?: React.ComponentType<React.SVGProps<SVGSVGElement>>;
    items?: {
      title: string;
      url: string;
    }[];
  }[];
}) {
  const sharedClasses =
    'peer/menu-button w-full overflow-hidden rounded-md p-2 text-left outline-none ring-sidebar-ring transition-[width,height,padding] focus-visible:ring-2 active:bg-sidebar-accent disabled:pointer-events-none disabled:opacity-50 group-has-[[data-sidebar=menu-action]]/menu-item:pr-8 aria-disabled:pointer-events-none aria-disabled:opacity-50 data-[state=open]:hover:bg-sidebar-accent data-[state=open]:hover:text-sidebar-accent-foreground group-data-[collapsible=icon]:!size-8 group-data-[collapsible=icon]:!p-2 [&>span:last-child]:truncate [&>svg]:size-4 [&>svg]:shrink-0 hover:bg-muted/50 hover:text-primary active:text-primary text-muted-foreground data-[active=true]:bg-muted/50 data-[active=true]:text-primary data-[active=true]:font-semibold data-[active=true]:border-primary border-transparent h-7 text-xs font-semibold group-data-[collapsible=icon]:!border-none flex items-center gap-2';

  const { setOpenMobile, open } = useSidebar();
  return (
    <SidebarGroup>
      <SidebarGroupLabel>Other</SidebarGroupLabel>
      <SidebarMenu>
        {items.map((item) => {
          const isExternal = item.url.startsWith('http'); // Check if the URL is external

          return (
            <SidebarMenuItem key={item.title}>
              {isExternal ? (
                <a
                  href={item.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={sharedClasses} // Apply the same classes as the button
                  data-sidebar="menu-button"
                  data-size="sm"
                  data-active="false"
                  title={item.title}
                >
                  {item.icon && <item.icon className="h-5 w-5" />}
                  <span>{item.title}</span>
                </a>
              ) : (
                <NavLink to={item.url} onClick={() => setOpenMobile(false)}>
                  {({ isActive }) => (
                    <SidebarMenuButton
                      isActive={isActive}
                      variant="primary"
                      size="sm"
                      data-sidebar="menu-button"
                      data-size="sm"
                      data-active={isActive ? 'true' : 'false'}
                      tooltip={{
                        children: item.title,
                        hidden: open,
                      }}
                    >
                      {item.icon && <item.icon className="h-5 w-5" />}
                      <span>{item.title}</span>
                    </SidebarMenuButton>
                  )}
                </NavLink>
              )}
            </SidebarMenuItem>
          );
        })}
      </SidebarMenu>
    </SidebarGroup>
  );
}
